export default __webpack_public_path__ + "static/media/FLK.01ce55c6.svg";